export default [
  {
    path: '/marketing-store',
    name: 'ExcellentMarketingStore',
    component: () => import('@/pages/ExcellentMarketingStore.vue'),
    meta: {
      title: '우수 마케팅 매장 인증제도',
      layout: 'DefaultLayout',
    },
  },
]
